<!-- tablesearchmiscellaneousreimbursement.vue -->

<template>
    <div>
        <div>
            <HeadDetailsGama :titleHead="'Detalhes da APR'"  :buttontemplate="true" :buttonbackCustom="true" style="font-family: 'Segoe UI';">
                <template #button-edit>
                    <div class="d-flex" v-if="propApr.statusApr == 0">
                        <div class="cancelar">
                            <button class="button-cancel" >CANCELAR</button>
                        </div>
                        <div class="criar ml-3">
                            <button class="button-save">SALVAR</button>
                        </div>
                    </div>
              </template>
            </HeadDetailsGama>
            <mediasApr ref="mediaApr" :listMidia="listMidia" :isPdf=false></mediasApr>
        </div>
        <div>

        </div>
    </div>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import HeadDetailsGama from '@/views/private/realestate/components/HeadDetails.vue'
import mediasApr from '@/views/private/apr/inqueryApr/components/inqueryTable/components/inqueryDetailsApr/components/inqueryDetailsTableApr/components/medias/components/mediaApr/mediaApr.vue'
import AprAnalisePreliminarRisco from '@/shared/http/repositories/business/aprInquery'
import { loading } from '@/shared/utils/UIHelper'

export default {
  name: 'tablesearchmiscellaneousreimbursement',
  mixins: [ActionsForm],
  components: {HeadDetailsGama, mediasApr},
  data () {
    return {
      coluna: [],
      dataFucionario: [],
      formSearch: {},
      totalDiversos: null,
      listMidia: null
    }
  },
  props: ['propApr'],
  watch: {
  },
  mounted () {
  },
  methods: {
    async onLoad () {
      loading.push()
      if (this.propApr.id !== null) {
        AprAnalisePreliminarRisco.GetAprMedia(this.propApr.id)
          .then(Response => {
            this.listMidia = Response.data.data
            loading.pop()
          })
          .catch()
      }
    },
    onSelect (data) {
      this.$emit('edit', data)
      this.$emit('filtro', this.formSearch)
    }
  }
}

</script>

<style scoped>
.buttons-table-action{
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: right;
    align-items: center;
}

.btn-generate-lote {
    height: 2rem;
    padding: 0 1rem;
    background: #008144;
    color: white;
    border-radius: 8px;
    border: none;
    font-weight: bold;
}
.btn-generate-lote:hover{
    background: #024d2a;
}

.form-inputs{
    width: 100%;
    padding: 0.5rem 0;
}
.labelsearch{
    font-weight: 700;
    color: #666;
    font-size: 14px;
    margin-bottom: 5px;
    padding-bottom: 0;
    font-family: 'Segoe UI';
}
.input-paddi{
  padding-left: 28px;
}

.button-cancel,
.button-save{
margin-top: 10;
outline: transparent;
border: transparent;
border-radius: 4px;
text-transform: uppercase;
width: 190px;
height: 40px;
}

.container_cancel_save{
justify-content: center;
width: 100%;
margin-top: 1.5rem;
column-gap: 10px;
}

.button-cancel{
background-color: #D8D8D8;
color: #636363;
}
.button-save{
background-color: #008148;
color: white;
}
</style>



// WEBPACK FOOTER //
// src/views/private/apr/inqueryApr/components/inqueryTable/components/inqueryDetailsApr/components/inqueryDetailsTableApr/components/medias/medias.vue